import { makeDraftClaimLineItemLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData: useQuantityData } =
  makeDraftClaimLineItemLoader(({ context }) => {
    const {
      draftClaimLineItem: {
        quantity,
        lineItem: { remainingReturnableQuantity },
      },
      crewClaim: { claimType },
    } = context;

    return remainingReturnableQuantity === 1 ?
        redirect('../reason')
      : {
          remainingReturnableQuantity,
          quantity,
          claimType,
        };
  });
